import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import Preloader from './components/Preloader';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
// import SnowEffect from './components/SnowEffect';

import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import Patients from './pages/admin/Patients';
import NewPatient from './pages/admin/NewPatient';
import Inventory from './pages/admin/Inventory';
import Payments from './pages/admin/Payments';
import AdminDelivery from './pages/admin/AdminDelivery';
import Login from './pages/admin/Login';
import Register from './pages/admin/Register';
import { authService } from './services/api';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, isAuthenticated, authenticating }) => {
  if (authenticating) return null;
  return isAuthenticated ? children : <Navigate to="/admin/login" />;
};

function App() {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authenticating, setAuthenticating] = useState(true);

  useEffect(() => {
    // Initial Preloader
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500);

    // Initial Auth Check
    checkAuth();

    return () => clearTimeout(timer);
  }, []);

  const checkAuth = async () => {
    try {
      const res = await authService.check();
      setIsAuthenticated(res.authenticated);
    } catch (e) {
      setIsAuthenticated(false);
    } finally {
      setAuthenticating(false);
    }
  };

  return (
    <Router>
      <div className="font-poppins selection:bg-syana-blue-100 selection:text-syana-blue-900">
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        <Preloader loading={loading} />
        
        {!loading && (
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<><ScrollToTop /><Navbar /><Home /><Footer /></>} />
            <Route path="/about-us" element={<><ScrollToTop /><Navbar /><AboutUs /><Footer /></>} />
            <Route path="/privacy-policy" element={<><ScrollToTop /><Navbar /><PrivacyPolicy /><Footer /></>} />
            <Route path="/terms-of-use" element={<><ScrollToTop /><Navbar /><TermsOfUse /><Footer /></>} />

            {/* Auth Routes */}
            <Route path="/admin/login" element={
              isAuthenticated ? <Navigate to="/admin" /> : <Login setAuth={setIsAuthenticated} />
            } />

            {/* Hidden Admin Registration — not linked in UI, PIN-protected */}
            <Route path="/admin/register" element={
              isAuthenticated ? <Navigate to="/admin" /> : <Register />
            } />

            {/* Protected Admin Routes */}
            <Route path="/admin" element={<ProtectedRoute isAuthenticated={isAuthenticated} authenticating={authenticating}><AdminLayout setIsAuthenticated={setIsAuthenticated}><AdminDashboard /></AdminLayout></ProtectedRoute>} />
            <Route path="/admin/patients" element={<ProtectedRoute isAuthenticated={isAuthenticated} authenticating={authenticating}><AdminLayout setIsAuthenticated={setIsAuthenticated}><Patients /></AdminLayout></ProtectedRoute>} />
            <Route path="/admin/patients/new" element={<ProtectedRoute isAuthenticated={isAuthenticated} authenticating={authenticating}><NewPatient /></ProtectedRoute>} />
            <Route path="/admin/inventory" element={<ProtectedRoute isAuthenticated={isAuthenticated} authenticating={authenticating}><AdminLayout setIsAuthenticated={setIsAuthenticated}><Inventory /></AdminLayout></ProtectedRoute>} />
            <Route path="/admin/payments" element={<ProtectedRoute isAuthenticated={isAuthenticated} authenticating={authenticating}><AdminLayout setIsAuthenticated={setIsAuthenticated}><Payments /></AdminLayout></ProtectedRoute>} />
            <Route path="/admin/delivery" element={<ProtectedRoute isAuthenticated={isAuthenticated} authenticating={authenticating}><AdminLayout setIsAuthenticated={setIsAuthenticated}><AdminDelivery /></AdminLayout></ProtectedRoute>} />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;
